import { ErrorFilled } from "@/assets/icons";
import { FC } from "react";
import { Row, RowSize } from "../row";
import styles from "./styles.scss";
import { WarningPanelProps } from "./types";

export const WarningPanel: FC<WarningPanelProps> = ({ title, text }) => {
  return (
    <Row size={RowSize.Small}>
      <div className={styles.body}>
        <ErrorFilled className={styles.icon} />
        <span className={styles.label}>{title}:</span>
        <span>{text}</span>
      </div>
    </Row>
  );
};
